// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606081011/js/" + chunkId + "." + {"44":"39e12759","225":"5ad4b958","481":"40b6011e","486":"5fe31edb","770":"34a6ee98"}[chunkId] + ".0.803109917046029.chunk.js";
};